module.exports = __webpack_public_path__ + "img/github.dda4ed64.png";